import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import Typography from '@material-ui/core/Typography';
import PropTypes from "prop-types";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
    },
    height100: {
        height: '100%'
    },
    title: {
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.main,
        fontWeight: 'bold'
    }
}));

export default function BoxOpcoes(props) {
    const {
        title = "Opções",
        stretchHeight = true,
        className = '',
        children
    } = props;
    const classes = useStyles();

    return (
        <Paper elevation={3} className={clsx(classes.root, stretchHeight && classes.height100, className)}>
            <Typography variant="h5" gutterBottom className={classes.title}>
                {title}
            </Typography>
            {children}
        </Paper>
    );
};

BoxOpcoes.propTypes = {
    title: PropTypes.string,
    stretchHeight: PropTypes.bool,
    className: PropTypes.string
};
